import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary';
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  variant = 'primary',
  children,
  className = '',
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-md transition-all duration-300 ease-out cursor-pointer text-center';
  const variants = {
    primary: 'bg-brand-orange text-white hover:bg-brand-orangeDark shadow-[0_8px_24px_rgba(230,126,34,0.3)] hover:shadow-[0_12px_32px_rgba(230,126,34,0.4)] hover:scale-[1.03] active:scale-[0.98] tracking-[0.5px] px-8 py-[18px] md:px-12 text-[15px] md:text-[16px] lg:text-[18px]',
    secondary: 'bg-transparent border-2 border-brand-orange text-brand-orange hover:bg-brand-orange/10 hover:border-white hover:text-white px-8 py-[14px] text-[15px]',
    tertiary: 'bg-[#E8E8E8] text-brand-navy hover:bg-[#D0D0D0] px-8 py-[14px] text-[15px]'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-21">
      {children}
    </button>;
}